import React from 'react'

import './Footer.scss'

export default ({ children }) => <article className="footer">{children}</article>
